import * as React from "react";
import { SVGProps } from "react";
const SvgPutIntoFolder = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 32 33" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M28 8H4c-.731 0-1.409.212-2 .556V4c0-1.103.897-2 2-2h7.586l2.707 2.707A.996.996 0 0 0 15 5h13c1.103 0 2 .897 2 2v1.556A3.962 3.962 0 0 0 28 8Zm-10.977 5.339c2.426 1.792 5.039 4.478 7.766 7.983a1 1 0 0 1-1.578 1.228c-2.175-2.795-4.258-5.034-6.207-6.677v15.129a1 1 0 1 1-2 0V15.867c-1.951 1.643-4.036 3.884-6.215 6.682A1 1 0 1 1 7.21 21.32c2.729-3.506 5.342-6.192 7.767-7.982a1.713 1.713 0 0 1 2.045 0ZM12 0c.266 0 .52.105.707.293L15.414 3H28c2.206 0 4 1.794 4 4v17c0 2.206-1.794 4-4 4h-8.996v-2H28c1.103 0 2-.897 2-2V12c0-1.103-.897-2-2-2H4c-1.103 0-2 .897-2 2v12c0 1.103.897 2 2 2h9v2H4c-2.206 0-4-1.794-4-4V4c0-2.206 1.794-4 4-4h8Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgPutIntoFolder;
